export default "__VITE_ASSET__CHCgb_Us__"